import React, { useContext, useState } from 'react';
import { Accordion, AccordionRow, Button, Container, TabPanel, Tabs } from '@paypalcorp/pp-react';
import { ApplicationContext } from '@MerchantConfigurator/context';
import {
  ConfigValues,
  MessagingAttributes,
  MessagingPlacementMessages,
  PageNames
} from '@MerchantConfigurator/constants';
import styles from './ControlPanel.module.less';
import PlacementControls from '@MerchantConfigurator/components/messaging/ControlPanel/PlacementControls';
import classNames from 'classnames';
import CodeWrapper from './CodeWrapper';
import { trackFieldFocus, trackFieldClosed, trackTabClick } from '../../../../../lib/fpti';

export default ({
  activePlacementIndex,
  messagingConfig,
  setActivePlacementIndex,
  setMessagingConfig,
  showPartnerExperience,
  updateCounters,
  resetConfig
}) => {
  const { content, placements, onUpdate } = useContext(ApplicationContext);
  const [isCustomizationsOpen, setIsCustomizationsOpen] = useState(true);
  const [isCodeOpen, setIsCodeOpen] = useState(false);

  const generateTabs = () => {
    const tabs = [];

    for (const placement of placements) {
      tabs.push({
        label: content[MessagingPlacementMessages[placement]],
        id: placement,
        panelId: placement
      });
    }
    return tabs;
  };
  const tabs = generateTabs();
  const updateConfig = ({ attribute, placement, value, placementConfigIndex }) => {
    let defaultLogoPosition;
    //This is to default the logo-position per placement for the initial selection of logo-type primary.
    if (
      attribute === MessagingAttributes.logoType &&
      value === ConfigValues.logoType.primary &&
      !messagingConfig[placement][MessagingAttributes.logoPosition]
    ) {
      defaultLogoPosition = {
        [MessagingAttributes.logoPosition]: ConfigValues.logoPosition.left
      };
    }
    let updatedConfig = {};

    //placementConfigIndex determines if the placement has a config in an array. Example: custom_placement
    if (placementConfigIndex >= 0) {
      const currentConfig = messagingConfig[placement][placementConfigIndex];
      currentConfig[attribute] = value;
      messagingConfig[placement].splice(placementConfigIndex, 1, currentConfig);
    } else {
      updatedConfig = {
        [placement]: {
          ...messagingConfig[placement],
          ...{
            [attribute]: value,
            ...(defaultLogoPosition && defaultLogoPosition)
          }
        }
      };
    }

    setMessagingConfig({
      ...messagingConfig,
      ...updatedConfig
    });

    onUpdate({ ...messagingConfig, ...updatedConfig });
  };

  const customizationsClassnames = classNames(styles.accordion_row_content, {
    [styles.accordion_row_closed]: !isCustomizationsOpen,
    [styles.accordion_row_opened]: isCustomizationsOpen
  });

  const codeClassnames = classNames(styles.accordion_row_content, {
    [styles.accordion_row_closed]: !isCodeOpen,
    [styles.accordion_row_opened]: isCodeOpen
  });

  return (
    <div>
      <Tabs
        className={styles.tabs}
        name="TabsGroup1"
        selectedTabIdx={activePlacementIndex}
        tabs={tabs}
        onClick={(_e, i) => {
          setActivePlacementIndex(i);
          trackTabClick(tabs[i].label);
        }}
      >
        {placements.map((placement, index) => (
          <TabPanel id={placement} tabId={placement} className={styles.tab_panel}>
            <Accordion className={styles.accordion}>
              <AccordionRow
                contentClassName={customizationsClassnames}
                headerClassName={styles.accordion_row_header}
                heading={'Customizations'}
                onClick={() => {
                  setIsCustomizationsOpen(!isCustomizationsOpen);
                  trackFieldFocus('Customizations');
                }}
                isOpen={isCustomizationsOpen}
              >
                <PlacementControls
                  label={content[MessagingPlacementMessages[placement]]}
                  placement={placement}
                  placementConfig={messagingConfig[placement]}
                  placementIndex={index}
                  updateActiveIndex={() => {}}
                  setActivePlacementIndex={setActivePlacementIndex}
                  shouldExpand={false}
                  showPartnerExperience={showPartnerExperience}
                  updateConfig={updateConfig}
                  updateCounters={updateCounters}
                />
              </AccordionRow>
            </Accordion>
            <Accordion className={styles.accordion}>
              <AccordionRow
                contentClassName={codeClassnames}
                headerClassName={styles.accordion_row_header}
                heading={'Code'}
                onClick={() => {
                  setIsCodeOpen(!isCodeOpen);
                  isCodeOpen ? trackFieldClosed('Code') : trackFieldFocus('Code');
                }}
                isOpen={isCodeOpen}
                subHeading={`Add the code to the body of your ${
                  PageNames[placement] || 'product'
                } page to display Pay Later messaging and update the data-pp-amount:`}
              >
                <CodeWrapper
                  messagingConfig={messagingConfig[placement]}
                  label={content[MessagingPlacementMessages[placement]]}
                />
              </AccordionRow>
            </Accordion>
          </TabPanel>
        ))}
      </Tabs>
      <Button secondary inverse onClick={resetConfig}>
        Reset to our recommendations
      </Button>
    </div>
  );
};
